import { render } from "./commodity-tooltip.vue?vue&type=template&id=42e0e829&ts=true"
import script from "./commodity-tooltip.vue?vue&type=script&lang=ts"
export * from "./commodity-tooltip.vue?vue&type=script&lang=ts"

import "./commodity-tooltip.vue?vue&type=style&index=0&id=42e0e829&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__